import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { retry, catchError, finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { environment } from '../../../environments/environment';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, SessionStorageService, CookieService } from '@collab/comp-library';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(public loaderService: LoaderService, private cookieService: CookieService, private sessionStorage: SessionStorageService) {
    }
    retryMaxCount = 3
    excludeUrls = [
        'ava/aipo/api/chaos/job/detail',
        'ava/aipo/accelerator/selfhelp/api/v1/job/details?jobRunId',
        'ava/aipo/live/dashboard/api',
    ];

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.excludeUrls.some(path => request.url.includes(path))) {
            this.loaderService.serviceStarted(request.url);
        }
        return next.handle(request)
            .pipe(
                retry({ count: this.retryMaxCount, delay: this.shouldRetry(this.retryMaxCount, 2000) }),
                finalize(() => this.loaderService.serviceCompleted(request.url)),
                catchError((error: HttpErrorResponse) => {
                    let errorMessage = '';
                    if (error.status === 401) {
                    } else if (error.status === 400) {
                      return throwError(error);
                    } else if (error.error instanceof ErrorEvent) {
                        errorMessage = `Error: ${error.error.message}`;
                        return throwError(errorMessage);
                    }
                  return throwError(error);
                })
            );
    }

    shouldRetry(maxRetryCount: number, duration: number) {
        return (error: HttpErrorResponse, count: number) => {
            if (error.status === 401) {
                if (count >= maxRetryCount) {
                }
                return timer(duration)
            }
            throw error
        }
    }
}
